module.exports = __webpack_public_path__ + "static/abbathor-symbol-DND3_FnP-d9bb1113c37ce15598079d322c9300a6.webp";